module.exports = __webpack_public_path__ + "static/media/Violation tooth angulation10.8d894c79.png";